// A printout in its own window, opened from a click (a window opened after an await would be blocked):
// the page is written into a blank window, then printed once it and its logo have loaded (the print
// dialog also offers Save as PDF). The blank window takes the app's Content-Security-Policy
// (script-src 'self'), so a script written into the page never runs there; the app drives the window
// from here instead: an optional `prepare` (e.g. fitting a form to one page), then the print dialog.
// Used by the boat yard forms (boatDocPrint.ts) and the Vessel Entry & Work Control Form
// (vesselEntryPrint.ts), on phones as on desktops.

/** open `html` in a new window and print it. Returns false when the browser blocked the pop-up, so the
 *  caller can say so. */
export function printInWindow(html: string, prepare?: (doc: Document) => void, features = 'width=900,height=1100'): boolean {
  const w = window.open('', '_blank', features);
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  let done = false;
  const go = () => {
    if (done || w.closed) return;
    done = true;
    try {
      prepare?.(w.document);
    } catch {
      // a page that can't be fitted still prints as it is
    }
    w.focus();
    w.print();
  };
  // a moment after load, so the fonts have settled before the page is measured and printed
  if (w.document.readyState === 'complete') setTimeout(go, 200);
  else w.addEventListener('load', () => setTimeout(go, 200), { once: true });
  return true;
}
